<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
  >
    <path d="M0.83229 8.39698C0.0511438 7.61603 0.051142 6.34985 0.832289 5.5689L5.81685 0.585591C6.59799 -0.195359 7.86448 -0.195361 8.64563 0.585591L13.6302 5.5689C14.4113 6.34985 14.4113 7.61602 13.6302 8.39698L8.64563 13.3803C7.86448 14.1612 6.59799 14.1612 5.81685 13.3803L0.83229 8.39698ZM1.53948 6.27592C1.14891 6.6664 1.14891 7.29948 1.53948 7.68996L6.52404 12.6733C6.91461 13.0637 7.54786 13.0637 7.93843 12.6733L12.923 7.68996C13.3136 7.29948 13.3136 6.6664 12.923 6.27592L7.93843 1.29261C7.54786 0.902134 6.91461 0.902134 6.52404 1.29261L1.53948 6.27592Z" />
  </svg>
</template>
